export default __webpack_public_path__ + "static/media/R3koritu.e554bf06.mp3";